// Build v2 - Cloudflare cache fix
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import { AdminRoute } from './components/AdminRoute';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { AddMoneyPage } from './pages/AddMoneyPage';
import { WithdrawPage } from './pages/WithdrawPage';
import { TransactionsPage } from './pages/TransactionsPage';
import { WithdrawalsPage } from './pages/WithdrawalsPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { AdminCommissionsPage } from './pages/AdminCommissionsPage';
import { AdminReferralsPage } from './pages/AdminReferralsPage';
import { AdminPaymentConfigPage } from './pages/AdminPaymentConfigPage';

const APP_VERSION = '2.0.0'; // v2 deployed

function App() {
  // Add version to console for verification
  React.useEffect(() => {
    console.log('App Version:', APP_VERSION);
  }, []);
  
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/add-money"
            element={
              <PrivateRoute>
                <AddMoneyPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/withdraw"
            element={
              <PrivateRoute>
                <WithdrawPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <PrivateRoute>
                <TransactionsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/withdrawals"
            element={
              <PrivateRoute>
                <WithdrawalsPage />
              </PrivateRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminRoute>
                  <AdminDashboardPage />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <PrivateRoute>
                <AdminRoute>
                  <AdminUsersPage />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/commissions"
            element={
              <PrivateRoute>
                <AdminRoute>
                  <AdminCommissionsPage />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/referrals"
            element={
              <PrivateRoute>
                <AdminRoute>
                  <AdminReferralsPage />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/payment-config"
            element={
              <PrivateRoute>
                <AdminRoute>
                  <AdminPaymentConfigPage />
                </AdminRoute>
              </PrivateRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
